{
  "common": {
    "memberCenter": "Espace membre",
    "points": "Points",
    "level": "Niveau",
    "coupons": "Coupons",
    "checkin": "Connexion quotidienne",
    "history": "Historique",
    "balance": "Solde",
    "expire": "Expirer",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "loading": "Chargement...",
    "noData": "Aucune donnée",
    "retry": "Réessayer",
    "success": "Succès",
    "failed": "Échec"
  },
  "points": {
    "earn": "{amount} points gagnés",
    "spend": "{amount} points dépensés",
    "balance": "Solde actuel : {amount} points",
    "expired": "{amount} points expirés",
    "estimated": "Estimation (en attente de confirmation)"
  },
  "level": {
    "current": "Niveau actuel : {name}",
    "nextLevel": "Niveau suivant : {name}",
    "progress": "{current}/{target} pour le niveau suivant",
    "upgraded": "Félicitations ! Niveau {name} atteint"
  },
  "coupon": {
    "claim": "Récupérer",
    "claimed": "Récupéré",
    "expired": "Expiré",
    "used": "Utilisé",
    "validUntil": "Valable jusqu'au {date}",
    "threshold": {
      "none": "Sans minimum",
      "min": "Commande minimum {amount}"
    }
  },
  "checkin": {
    "today": "Connexion du jour",
    "done": "Déjà connecté",
    "streak": "{days} jours consécutifs",
    "reward": "+{amount} points"
  },
  "errors": {
    "network": "Erreur réseau, veuillez réessayer",
    "unauthorized": "Veuillez vous connecter",
    "serverError": "Erreur serveur, veuillez réessayer plus tard",
    "timeout": "Délai d'attente dépassé"
  },
  "ui": {
    "memberCenter": {
      "loading": "Chargement...",
      "avatarAlt": "Avatar du membre",
      "pointsBalance": "Mes points",
      "menuLabel": "Navigation membre",
      "menu": {
        "pointsDetail": "Historique des points",
        "levelDetail": "Avantages du niveau",
        "coupons": "Mes coupons",
        "referral": "Inviter des amis",
        "checkin": "Connexion quotidienne",
        "orders": "Mes commandes",
        "exchange": "Boutique de points",
        "address": "Mes adresses",
        "profile": "Mon profil",
        "account": "Paramètres du compte"
      }
    },
    "pointsDetail": {
      "title": "Historique des points",
      "empty": "Aucun historique de points",
      "loading": "Chargement...",
      "noMore": "Plus aucun enregistrement",
      "listLabel": "Transactions de points",
      "status": {
        "pending": "En attente",
        "active": "Actif",
        "used": "Utilisé",
        "expired": "Expiré"
      }
    },
    "levelProgress": {
      "loading": "Chargement...",
      "maxLevel": "Niveau maximum atteint",
      "progressLabel": "Progression du niveau",
      "noBenefits": "Aucun avantage",
      "nextLevel": "Niveau suivant : {name}",
      "benefitsTitle": "Mes avantages"
    },
    "couponList": {
      "title": "Mes coupons",
      "tabsLabel": "Catégories de coupons",
      "listLabel": "Liste des coupons",
      "empty": "Aucun coupon disponible",
      "freeShipping": "Livraison gratuite",
      "giftValue": "Cadeau",
      "discountValue": "{value}% de réduction",
      "type": {
        "discount": "Réduction",
        "cash": "Espèces",
        "shipping": "Livraison",
        "gift": "Cadeau"
      },
      "tab": {
        "unused": "Non utilisé",
        "used": "Utilisé",
        "expired": "Expiré",
        "claimable": "Obtenir"
      },
      "loadingClaimable": "Chargement...",
      "noClaimable": "Aucun coupon disponible",
      "claiming": "Obtention...",
      "claim": "Obtenir",
      "stockInfo": "{remaining} restants",
      "stockUnlimited": "Illimité",
      "minOrder": "Min. {amount}"
    },
    "referralShare": {
      "loading": "Chargement...",
      "title": "Inviter des amis",
      "shareTitle": "Invitez vos amis et gagnez des points",
      "shareText": "Inscrivez-vous et recevez un cadeau !",
      "invitedCount": "Invités",
      "rewardPoints": "Points gagnés",
      "codeLabel": "Mon code de parrainage",
      "linkLabel": "Lien de parrainage",
      "copy": "Copier",
      "copyCode": "Copier le code de parrainage",
      "share": "Partager",
      "rewardHint": "Gagnez {points} points par ami invité",
      "tabShare": "Inviter",
      "tabRecords": "Historique",
      "loadingRecords": "Chargement...",
      "noRecords": "Aucune invitation",
      "anonymousUser": "Anonyme",
      "prevPage": "Précédent",
      "nextPage": "Suivant",
      "recordsLabel": "Liste des invitations",
      "status": {
        "registered": "Inscrit",
        "first_order": "1ère commande",
        "rewarded": "Récompensé"
      }
    },
    "checkinCalendar": {
      "loading": "Chargement...",
      "checking": "Connexion en cours...",
      "checkin": "Se connecter",
      "alreadyChecked": "Déjà connecté",
      "day": "{count} jours",
      "title": "Connexion quotidienne",
      "streak": "{days} jours consécutifs",
      "calendarLabel": "Calendrier de connexion",
      "rewardsTitle": "Récompenses de série",
      "rewardsLabel": "Liste des récompenses",
      "weekday": {
        "sun": "Dim",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam"
      },
      "prevMonth": "Mois précédent",
      "nextMonth": "Mois suivant",
      "monthDays": "{count} jours ce mois",
      "monthPoints": "Points du mois"
    },
    "orderList": {
      "loading": "Chargement des commandes...",
      "title": "Historique des commandes",
      "noOrders": "Aucune commande",
      "listLabel": "Liste des commandes",
      "prevPage": "Précédent",
      "nextPage": "Suivant",
      "typePoints": "Points",
      "typeGrowth": "Croissance",
      "bizType": {
        "Order_Pay": "Paiement commande",
        "Order_Refund": "Remboursement"
      },
      "status": {
        "pending": "En attente",
        "active": "Actif",
        "invalid": "Invalide",
        "used": "Utilisé",
        "expired": "Expiré"
      }
    },
    "addressManager": {
      "title": "Mes adresses",
      "add": "Ajouter",
      "empty": "Aucune adresse",
      "default": "Par défaut",
      "setDefault": "Définir par défaut",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "accountSettings": {
      "title": "Paramètres du compte",
      "dataExport": {
        "title": "Exporter mes données",
        "desc": "Télécharger une copie de vos données",
        "button": "Demander l'export",
        "processing": "Traitement..."
      },
      "deleteAccount": {
        "title": "Supprimer le compte",
        "desc": "Supprimer définitivement votre compte et données",
        "button": "Supprimer le compte",
        "confirm": "Cette action est irréversible. Toutes vos données seront supprimées.",
        "confirmButton": "Oui, supprimer",
        "cancel": "Annuler"
      }
    },
    "checkout": {
      "points": {
        "title": "Déduction de points",
        "unit": "pts",
        "available": "Disponible",
        "deduct": "Déduire"
      },
      "coupon": {
        "title": "Coupon",
        "none": "Aucun coupon"
      },
      "summary": {
        "order": "Total commande",
        "discount": "Remise",
        "total": "À payer"
      }
    },
    "profile": {
      "form": {
        "nickname": "Pseudo",
        "avatar": "URL de l'avatar",
        "locale": "Langue",
        "save": "Enregistrer",
        "saving": "Enregistrement..."
      }
    },
    "auth": {
      "login": {
        "emailLabel": "E-mail",
        "passwordLabel": "Mot de passe",
        "submit": "Se connecter",
        "createAccount": "Créer un compte",
        "forgotPassword": "Mot de passe oublié ?",
        "orDivider": "ou"
      },
      "register": {
        "emailLabel": "E-mail",
        "passwordLabel": "Mot de passe",
        "confirmPasswordLabel": "Confirmer le mot de passe",
        "passwordHint": "Au moins 8 caractères, avec des lettres et des chiffres",
        "submit": "Créer un compte",
        "hasAccount": "Vous avez déjà un compte ? Se connecter",
        "passwordMismatch": "Les mots de passe ne correspondent pas",
        "submitting": "Création..."
      },
      "oauth": {
        "continueWith": "Continuer avec {provider}"
      },
      "verify": {
        "title": "Vérifiez votre email",
        "description": "Nous avons envoyé un code de vérification à {email}",
        "digitLabel": "Chiffre {index}",
        "resend": "Renvoyer le code",
        "resendCountdown": "Renvoyer ({countdown}s)",
        "backToRegister": "Retour à l'inscription"
      },
      "forgot": {
        "title": "Réinitialiser le mot de passe",
        "description": "Entrez votre e-mail et nous vous enverrons un code de vérification.",
        "emailLabel": "E-mail",
        "submit": "Envoyer le code",
        "backToLogin": "Retour à la connexion"
      }
    },
    "error": {
      "network": "Erreur réseau, veuillez réessayer",
      "retry": "Réessayer",
      "retryLabel": "Recharger"
    }
  },
  "sdk": {
    "error": {
      "210900": "Paramètres invalides",
      "210901": "L'identifiant du locataire est requis",
      "210902": "Trop de requêtes, veuillez réessayer plus tard",
      "210903": "Non autorisé",
      "210904": "Jeton expiré",
      "210905": "Jeton invalide",
      "210906": "Échec du rafraîchissement du jeton",
      "210907": "Échec de l'échange de jeton de la plateforme",
      "210908": "Jeton de rafraîchissement invalide",
      "210909": "Jeton de rafraîchissement expiré",
      "210911": "Membre introuvable",
      "210912": "Informations de niveau introuvables",
      "210920": "Cet e-mail est déjà enregistré",
      "210921": "Mot de passe trop faible : au moins 8 caractères avec des lettres et des chiffres",
      "210922": "Code de vérification envoyé trop fréquemment, veuillez réessayer plus tard",
      "210923": "Code de vérification invalide ou expiré",
      "210924": "Informations d'inscription expirées, veuillez vous réinscrire",
      "210925": "E-mail ou mot de passe incorrect",
      "210926": "E-mail non vérifié, veuillez d'abord le vérifier",
      "210927": "Échec de l'authentification OAuth",
      "210928": "État OAuth invalide ou expiré",
      "210929": "Méthode de connexion non prise en charge",
      "210930": "Échec de la création de l'utilisateur",
      "210931": "Échec du calcul de la remise",
      "210951": "Échec de la requête du solde de points",
      "210952": "Échec de la requête des transactions de points",
      "210953": "Échec de l'accumulation de points",
      "210954": "Échec de l'activation des points",
      "210955": "Échec de la dépense de points",
      "210956": "Solde de points insuffisant",
      "210957": "Registre de points introuvable",
      "210958": "Le statut des points ne permet pas cette opération",
      "210971": "Coupon en rupture de stock",
      "210972": "Coupon déjà réclamé",
      "210981": "Échec de l'écriture dans la file de messages",
      "210982": "Échec de la synchronisation du service interne",
      "210983": "Produit d'échange introuvable",
      "210984": "Échec de l'échange",
      "210985": "Code de parrainage introuvable",
      "210986": "Échec de la liaison de parrainage",
      "210987": "Parrain introuvable",
      "210988": "Vous ne pouvez pas vous inviter vous-même",
      "210989": "Échec de la réclamation du coupon",
      "210990": "Déjà enregistré aujourd'hui",
      "210991": "Échec de l'enregistrement",
      "211001": "Échec de la vérification de la signature webhook",
      "211002": "Plateforme webhook non prise en charge",
      "211003": "Requête webhook en double",
      "211004": "Secret webhook non configuré",
      "211005": "Horodatage webhook expiré",
      "211900": "Opération échouée, veuillez réessayer",
      "211901": "Échec de l'authentification",
      "211902": "Compte non lié",
      "211903": "Accès refusé",
      "211904": "Configuration introuvable",
      "211905": "Portée de configuration invalide",
      "211906": "Rôle introuvable",
      "211907": "Le rôle système ne peut pas être supprimé",
      "211908": "Pas d'accès à ce locataire",
      "211909": "Échec de la validation",
      "211910": "Ressource introuvable",
      "211911": "Membre introuvable",
      "211912": "Conflit d'identité, veuillez contacter le support",
      "211913": "Échec de l'activation du compte fantôme",
      "211914": "Enregistrement de révision introuvable",
      "211915": "Le statut de l'enregistrement de révision n'est pas en attente",
      "211916": "OneID introuvable",
      "211917": "Échec de la dissociation OneID",
      "211931": "Configuration de niveau introuvable",
      "211932": "Le niveau a des membres associés, suppression impossible",
      "211933": "Échec de la validation de la condition de mise à niveau",
      "211934": "La séquence des niveaux doit être continue",
      "211951": "Transition de statut du registre invalide",
      "211952": "Solde de points insuffisant",
      "211953": "Enregistrement du registre introuvable",
      "211954": "Transaction de points en double",
      "211955": "Montant de points invalide",
      "211956": "La déduction de points dépasse le ratio maximum",
      "211957": "Points en dessous du seuil minimum",
      "211958": "Règle d'accumulation de points non configurée",
      "211959": "Échec de l'activation des points : le statut n'est pas en attente",
      "211960": "Accès refusé à la transaction de points",
      "211961": "Points déjà expirés",
      "211962": "Règle de croissance non configurée",
      "211971": "Modèle de coupon introuvable",
      "211972": "Statut du modèle de coupon invalide",
      "211973": "Limite de coupons par utilisateur dépassée",
      "211974": "Quota total de coupons dépassé",
      "211975": "Statut d'utilisation du coupon invalide",
      "211976": "Coupon expiré",
      "211977": "Le modèle de coupon a des coupons émis, suppression impossible",
      "211981": "Tâche de notification introuvable",
      "211982": "Le statut de la tâche de notification ne permet pas la modification",
      "211983": "Le statut de la tâche de notification ne permet pas l'annulation",
      "211984": "Modèle de notification introuvable",
      "211985": "L'audience cible de la notification est vide",
      "211991": "Service occupé, veuillez réessayer plus tard",
      "211992": "Échec de la publication du message",
      "211993": "Message entré dans la file des lettres mortes",
      "network": "Erreur réseau, veuillez vérifier votre connexion",
      "timeout": "Délai d'attente dépassé, veuillez réessayer",
      "aborted": "Requête annulée",
      "parse": "Erreur d'analyse de la réponse",
      "unauthorized": "Veuillez d'abord vous connecter",
      "config": "Erreur d'initialisation du SDK",
      "unknown": "Une erreur inconnue s'est produite"
    }
  },
  "exchange": {
    "store": {
      "title": "Boutique points",
      "myOrders": "Mes échanges",
      "empty": "Aucun produit disponible",
      "points": "points",
      "stock": "Stock",
      "back": "Retour",
      "redeem": "Échanger",
      "soldOut": "Épuisé",
      "noOrders": "Aucun échange",
      "status": {
        "pending": "En attente",
        "completed": "Terminé",
        "cancelled": "Annulé"
      }
    }
  },
  "message": {
    "center": {
      "title": "Messages",
      "empty": "Aucun message"
    },
    "type": {
      "system": "Système",
      "marketing": "Promotions",
      "transaction": "Transaction",
      "activity": "Activité"
    }
  }
}
